import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { MainButton } from './MainButton';
import { translationKeys } from '~/models';

const Root = styled('div')(({ theme }) => ({
  background: 'linear-gradient(to top, #fff 20%, rgba(255,255,255,0.9) 30%)',
  bottom: 0,
  boxSizing: 'border-box',
  justifySelf: 'flex-end',
  padding: theme.spacing(3),
  position: 'absolute',
  width: '100%',
  zIndex: 2,
}));

export const Footer: FC = () => {
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId('footer')}>
      <MainButton>
        <FormattedMessage id={translationKeys.goToBasket} />
      </MainButton>
    </Root>
  );
};
